import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Meta } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class MetaService {
  private defaultDescription = 'Looking for Cheap Airfare? Book domestic and international flights at unbeatable fares with BelairTrip. Enjoy exclusive deals and save big on your next flight booking.';
  constructor(private titleService: Title, private metaService: Meta) { 
    this.updateMeta;
  }

  updateMeta(title: string, description: string, keywords?: string) {
    const defaultMessage = 'Book Domestic & International Flight Tickets at Low Airfares';
    const updatedTitle = title.includes(defaultMessage) ? title : `${title}`;
    const updatedDescription = description && description.trim() ? description : this.defaultDescription;
    const updatedKeywords = keywords && keywords.trim() ? keywords : '';
    
    this.titleService.setTitle(updatedTitle);
    this.metaService.updateTag({ name: 'description', content: updatedDescription });
    this.metaService.updateTag({ name: 'keywords', content: updatedKeywords }); 
    // OG Title Update Content
    this.metaService.updateTag({ property: 'og:title', content: updatedTitle });
    this.metaService.updateTag({ property: 'og:description', content: updatedDescription });
    // twitter Title Update Content
    this.metaService.updateTag({ name: 'twitter:title', content: updatedTitle });
    this.metaService.updateTag({ name: 'twitter:description', content: updatedDescription });
  }

  getDefaultDescription(): string {
    return this.defaultDescription;
  }
}
